import { useState } from "react";
import { useSnackbar } from 'notistack';
import { Paper, Grid,FormGroup, Box, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { getEngineFleetReportApi } from "../apiService";
import { globalGetService } from "../../../utils/globalApiServices";
import { checkApiStatus } from "../../../utils";
import { ExportMenu, PageLoader } from "../../../shared_elements";
import Header from "./Header";
import LessorFilter from "./LessorFilter";
import AssetFilter from "./AssetFilter";
import { trackActivity } from "../../../utils/mixpanel";

const EngineFleetReport = ({ pltConstants, dropDownLoader }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false)
  const [reportData, setReportData] = useState({is_weekly_report : "false"});
  const onFieldChange = (key, value) => { setReportData({ ...reportData, [key]: value }) }
  const onExportReport = (extention,) => {
    const getIdArray = (arr) => arr?.length ? arr.map((i) => i.id) : undefined;
    const lessorIds = getIdArray(reportData?.lessor_name_id);
    const assetTypeIds = getIdArray(reportData?.asset_type_id);
    const query = {
      file_type: extention,
      ...(reportData?.is_weekly_report == "true" && { is_weekly_report: true }),
      ...(lessorIds && { lessor_name_id: lessorIds }),
      ...(assetTypeIds && { asset_id: assetTypeIds }),
    };
    setLoading(true)
    globalGetService(getEngineFleetReportApi(query))
      .then(response => {
        setLoading(false)
        if (checkApiStatus(response)) {
          setReportData({is_weekly_report : "false"})
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
          trackActivity('Item Export', { page_title: `Engine Fleet Report`, success_msg: response?.data?.message, payload: query, response: response?.data })
        } else {
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
          trackActivity('Item Export', { page_title: `Engine Fleet Report`, error_msg: response?.data?.message, payload: query, response: response?.data })
        }
      });
  };
  return (
    <Paper square>
      <div className='custom-rpt-card '>
        <div className='rpt-card-header'>
          <Grid container spacing={1} className='rpt-header-grid'>
            <Grid size={{ md: 10, xs: 10 }}>
              <Header title="Engine Fleet Report" description="Engines Fleet report capture the asset basic details and active lease and utilization and rates information." />
            </Grid>
            <Grid size={{ md: 2, xs: 2 }} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
              <ExportMenu
                exportReportFn={(file) => onExportReport(file.extension)}
                files={[{ title: 'EXCEL', extension: 'xlsx' }]}
              />
            </Grid>
          </Grid>
        </div>
        <Grid sx={{ padding: 2 }} container spacing={1} >
        <Grid item size={{ md: 12, xs: 12 }}>
            <FormGroup className="disabled-checkbox-wrapper" sx={{ ml: "10px" }}>
              <Box sx={{ alignItems: "center", }}>
                <span className="check-item-span">Select Report Type</span>
                <RadioGroup row value={reportData?.is_weekly_report} >
                  <FormControlLabel  checked={reportData?.is_weekly_report == "false"} control={<Radio onChange={() => onFieldChange("is_weekly_report", "false")} disableRipple size="small" />} label="Fleet Report"  />
                  <FormControlLabel  checked={reportData?.is_weekly_report=="true"} control={<Radio onChange={() => onFieldChange("is_weekly_report","true")} disableRipple size="small" />} label="Weekly Report"  />
                </RadioGroup>
              </Box>
            </FormGroup>
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <LessorFilter pltConstants={pltConstants} dropDownLoader={dropDownLoader} reportData={reportData} onFieldChange={onFieldChange} />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <AssetFilter isRequired={false} pltConstants={pltConstants} dropDownLoader={dropDownLoader} reportData={reportData} onFieldChange={onFieldChange} />
          </Grid>
        </Grid>
      </div>
      {isLoading ? <PageLoader /> : null}
    </Paper>
  )
}

export default EngineFleetReport